import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import translations from './translations';

const Crate = ({ crate }) => (
  <>
    <Typography variant="overline" color="textSecondary">
      <FormattedHTMLMessage {...translations.properties.crate} />
    </Typography>
    <Typography variant="body2" color="textPrimary">
      {crate ?? '-'}
    </Typography>
  </>
);

Crate.propTypes = {
  crate: PropTypes.string,
};

Crate.defaultProps = {
  crate: undefined,
};

export default Crate;
